import { Swiper as SliderContainer, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper";
// @interfaces
import { IProject } from '../@interfaces/impact.interface';
import styles from '../styles/pages/payment/Basket.module.css';
import "swiper/css";
import "swiper/css/pagination";

interface BasketInformationProps {
  projects?: IProject[];
  merchantCode: string;
  hideLink?: boolean;
}

const BasketInformation: React.FC<BasketInformationProps> = ({ projects, merchantCode, hideLink }) => {
  return (
    <SliderContainer
      modules={[Pagination]}
      pagination={{ clickable: true }}
      className={styles.carouselContainer}
    >
      {projects?.map((project: any, index: number) => {
        return (
          <SwiperSlide
            className={styles.carouselItem}
            key={index}
          >
            <div
              className={styles.carouselImg}
              style={{
                background: `linear-gradient(to bottom, rgba(252, 252, 252, 0), rgba(0, 0, 0, 0.4)), url(${project?.thumbnailImageUrl})`,
              }}
            >
              <div style={{ width: "100%", display: 'flex'}}>
                <div>
                  <p className={styles.locationDescription}>
                    <svg width="16" height="21" viewBox="0 0 16 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fillRule="evenodd" clipRule="evenodd" d="M0 8.17C0.0438722 3.783 3.61278 0.249781 8 0.25C12.3872 0.249781 15.9561 3.783 16 8.17C16 13.65 9 19.75 8.65 20.01C8.27578 20.3301 7.72422 20.3301 7.35 20.01L7.34836 20.0086C7.02535 19.7287 0 13.6404 0 8.17ZM4.5 7.75C4.5 9.683 6.067 11.25 8 11.25C8.92826 11.25 9.8185 10.8813 10.4749 10.2249C11.1313 9.5685 11.5 8.67826 11.5 7.75C11.5 5.817 9.933 4.25 8 4.25C6.067 4.25 4.5 5.817 4.5 7.75Z" fill="white"/>
                    </svg>
                    <span style={{marginTop: '3px', marginLeft: '6px'}}>
                      {project?.locationDescription.toUpperCase()}
                    </span>
                  </p>
                  <p className={styles.shortDescription}>
                    {project?.name}
                  </p>
                </div>

                <div style={{
                  marginLeft: "auto",
                  display: 'flex',
                  alignItems: 'end'
                }}>
                  {!hideLink && <a
                      style={{height: '20px'}}
                      rel="noreferrer"
                      target='_blank'
                      href={`${process.env.REACT_APP_MY_CC_URL}/RM-${merchantCode}/projects/${project?.code}`}
                  >
                    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                          d="M16.6667 9.66667C16.2064 9.66667 15.8333 10.0398 15.8333 10.5V15.5C15.8333 15.9602 15.4602 16.3333 15 16.3333H5C4.53976 16.3333 4.16667 15.9602 4.16667 15.5V5.5C4.16667 5.03976 4.53976 4.66667 5 4.66667H10C10.4602 4.66667 10.8333 4.29357 10.8333 3.83333C10.8333 3.3731 10.4602 3 10 3H5C3.61929 3 2.5 4.11929 2.5 5.5V15.5C2.5 16.8807 3.61929 18 5 18H15C16.3807 18 17.5 16.8807 17.5 15.5V10.5C17.5 10.0398 17.1269 9.66667 16.6667 9.66667Z"
                          fill="white"/>
                      <path
                          d="M13.3333 4.66667H14.65L9.40833 9.9C9.25057 10.0565 9.16183 10.2695 9.16183 10.4917C9.16183 10.7139 9.25057 10.9269 9.40833 11.0833C9.56481 11.2411 9.7778 11.3298 10 11.3298C10.2222 11.3298 10.4352 11.2411 10.5917 11.0833L15.8333 5.85V7.16667C15.8333 7.6269 16.2064 8 16.6667 8C17.1269 8 17.5 7.6269 17.5 7.16667V3.83333C17.5 3.3731 17.1269 3 16.6667 3H13.3333C12.8731 3 12.5 3.3731 12.5 3.83333C12.5 4.29357 12.8731 4.66667 13.3333 4.66667Z"
                          fill="white"/>
                    </svg>
                  </a>}
                </div>
              </div>
            </div>


          </SwiperSlide>
        );
      })}
    </SliderContainer>
  )
};

export default BasketInformation;
